import { useParams } from "react-router"
import { TaskDetail } from "./TaskDetail";

export function TaskDetailContainer() {
    const { id } = useParams();
    const taskId = parseInt(id ?? "0");
    return (
        <TaskDetail
            taskId={taskId}
            showNavButton/>
    )
}